import Offre from "./prop/Offre"

export default function Offres() {
    return (
        <section className="offres-container" id="offres">
            <Offre
                pack="Entreprise"
                prix='1000€'
                TTC={true}
                APartir={true}
                presentation={<>
                    Pour les entreprises qui souhaitent une présence en ligne <span className="red">complète</span> et <span className="red">professionnelle</span>.</>}
            >
                <li>Call de stratégie, établir des besoins et des réponses précises</li>
                <li>Elaboration d’un parcours utilisateur répondant à vos objectifs</li>
                <li>Création de l’interface / design</li>
                <li>Développement sur-mesure</li>
                <li>Possibilité de créer des plug-ins sur mesure</li>
                <li>Site responsive</li>
                <li>Protocole sécurisé HTTPS</li>
                <li>Site administrable</li>
                <li>Statistiques Google</li>
                <li>Formation sur votre nouveau site</li>
                <li>Optimisé pour le référencement SEO</li>
                <li>Un an de maintenance technique</li>
            </Offre>
            
            <Offre
                pack="Début d'activité"
                prix='450€'
                TTC={true}
                presentation={<>
                    Pensé pour les <span className="red">auto-entrepreneurs</span>.  Minimisez vos coûts et vos risques tout en prenant l’initiative de faire décoller votre activité !
                </>
                }
            >
                <li>Un échange en visio ou par téléphone pour comprendre vos enjeux / besoins. </li>
                <li>Développement de votre site internet</li>
                <li>Site responsive </li>
                <li>Optimisé pour le référencement SEO</li>
                <li>Design simple (mais efficace !)</li>
                <li>Statistiques Google</li>
                <li>Protocole sécurisé HTTPS</li>
                <li>Un an de maintenance technique</li>
                <li>Site administrable</li>
                <li>Formation sur votre nouveau site !</li>
            </Offre>

            <Offre
                pack='"Je me démarque"'
                prix='Sur devis'
                presentation={<>Pour les entreprises déjà implantée ayant des <span className="red">objectifs précis</span> à le recherche <span className="red">d’un projet web répondant à leurs attentes</span></>}
            >
                <li>Réunion stratégique pour comprendre vos enjeux et trouvez LA solution web adaptée.</li>
                <li>Choix des technologies </li>
                <li>Recherche et création d’un parcours utilisateur pour répondre à vos objectifs UX</li>
                <li>Création de l’interface / design UI</li>
                <li>Prototypage</li>
                <li>Développement web sur-mesure</li>
                <li>Sécurisé</li>
                <li>Code optimisé, maintenable et évolutif</li>
                <li>Statistiques Google</li>
                <li>Mise en place d’une pipeline pour faire évoluer votre site à n’importe quel moment</li>
                <li>Un an de maintenance technique et de support.</li>
            </Offre>

        </section>
    )
}